import type { IExternalLineBaseData, ILineBaseData, IPoleBaseData } from "../models/IBaseDataModel";
import api from "./kyAuthenticatedInstance";

const PoleBaseDataService = {
  async getPoleBaseData(): Promise<IPoleBaseData[]> {
    return api.get(`PoleBaseData`).json<IPoleBaseData[]>();
  },
  async updatePoleBaseData(poleBaseData: IPoleBaseData): Promise<Response> {
    return api.put(`PoleBaseData`, {
      json: {
        ...poleBaseData
      }
    });
  },
  async createPoleBaseData(poleBaseData: IPoleBaseData): Promise<string> {
    return api.post(`PoleBaseData`, {
      json: {
        ...poleBaseData
      }
    }).text();
  },
  async deletePoleBaseData(poleBaseDataId: number): Promise<Response> {
    return api.delete(`PoleBaseData/${poleBaseDataId}`);
  }
};

const LineBaseDataService = {
  async getLineBaseData<T>(): Promise<T> {
    return api.get(`LineBaseData`).json<T>()
  },
  async getExternalLineBaseData(): Promise<IExternalLineBaseData[]> {
    return api.get(`LineBaseData/ExternalLineData`).json<IExternalLineBaseData[]>();
  },
  async updateLineBaseData(lineBaseData: ILineBaseData): Promise<Response> {
    return api.put(`LineBaseData`, {
      json: {
        ...lineBaseData
      }
    })
    //return axiosAuthenticatedInstance.put<unknown, AxiosResponse>(LineBaseDataPaths.UpdateLineBaseData, lineBaseData);
  },
  async createLineBaseData(lineBaseData: ILineBaseData): Promise<string> {
    return api.post(`LineBaseData`, {
      json: {
        ...lineBaseData
      }
    }).text();
  },
  async deleteLineBaseData(lineBaseDataId: number): Promise<Response> {
    return api.delete(`LineBaseData/${lineBaseDataId}`);
  }
};

export const BaseDataService = {
  ...PoleBaseDataService,
  ...LineBaseDataService
}